import { useCloudStatus } from "../hooks/use-cloud-status";
import { useCloudStatusRedirection } from "../hooks/use-cloud-status-redirection";
import { useConfirmationPageType } from "../hooks/use-confirmation-page-type";

import ErrorView from "./error/error-view";
import RobotsView from "./robots/robots-view";
import TimeoutView from "./timeout/timeout-view";
import TipsView from "./tips/tips-view";
import { LegacyConfirmationPageLayout } from "./view-switch";
/**
 * Component renders the approriate UI given the bundle
 * @returns @type {JSX.Element}
 */
export const BundleViewSwitch = () => {
    let confirmationPageView = <RobotsView />;
    const { createCloudStatus, startPerceivedProvisioningTimer } =
        useCloudStatus();
    const { deferRedirectView } = useCloudStatusRedirection();
    const confirmationPageType = useConfirmationPageType(
        createCloudStatus,
        deferRedirectView
    );
    switch (confirmationPageType) {
        case "tips":
            confirmationPageView = <TipsView />;
            break;
        case "timeout":
            confirmationPageView = <TimeoutView />;
            break;
        case "error":
            confirmationPageView = <ErrorView />;
            break;
        case "redirect":
            startPerceivedProvisioningTimer();
            confirmationPageView = <div id="redirectToProductContainer" />;
            break;
        default:
            startPerceivedProvisioningTimer();
            confirmationPageView = <RobotsView />;
    }
    return (
        <LegacyConfirmationPageLayout>
            {confirmationPageView}
        </LegacyConfirmationPageLayout>
    );
};
